import CreateListResourceInteractor from "../../core/interactor/app/crud/CreateListResourceInteractor";
import Constants from "../common/Constants";
import { IOrganisationIndexGroup } from "../model/OrganisationIndexGroup";
import OrganisationIndexGroupParamMapper from "../service/OrganisationIndexGroupParamMapper";

export default class ConnectIndexGroupsInteractor {
  private createListResource: CreateListResourceInteractor<IOrganisationIndexGroup>;

  constructor({ createListResource }: any) {
    this.createListResource = createListResource;
  }

  async execute(
    organisationIndexGroupId: number,
    organisationIndexGroups: IOrganisationIndexGroup[],
    organisationId: number,
    label?: string
  ) {
    return this.createListResource.execute(
      `${Constants.organisationsPath}/${organisationId}/groups/${organisationIndexGroupId}`,
      organisationIndexGroups,
      {
        query: {
          label,
        },
      },

      OrganisationIndexGroupParamMapper
    );
  }
}
